export const MAX_PROJECT_NAME_LENGTH = 255;
export const MIN_PROJECT_NAME_LENGTH = 1;

export const MAX_ROOM_NAME_LENGTH = 255;

export const MAX_PRODUCT_DIMENSION_X_Y_Z_LENGTH = 100;
export const MIN_PRODUCT_DIMENSION_X_Y_Z_LENGTH = 0;

export const MAX_PRODUCT_NAME_LENGTH = 255;
export const MIN_PRODUCT_NAME_LENGTH = 1;

export const MIN_PRODUCT_PRICE = 0;
export const MAX_PRODUCT_PRICE = 9999;

export const MIN_PRODUCT_DIMENSION = 0;
export const MAX_PRODUCT_DIMENSION = 9999;

export const MIN_PRODUCT_DESCRIPTION_LENGTH = 0;
export const MAX_PRODUCT_DESCRIPTION_LENGTH = 1024;

export const MIN_ZOOM_SPEED = 0.1;
export const MAX_ZOOM_SPEED = 10;
export const DEFAULT_ZOOM_SPEED = 1;

export const MIN_PAN_SPEED = 0.1;
export const MAX_PAN_SPEED = 10;
export const DEFAULT_PAN_SPEED = 1;

export const MAX_FIRST_NAME_LENGTH = 150;
export const MAX_LAST_NAME_LENGTH = 150;

export const MAX_DESIGNATION_LENGTH = 40;
export const MIN_DESIGNATION_LENGTH = 3;

export const DEFAULT_VERTICAL_ROTATION_SPEED = 30;
export const DEFAULT_HORIZONTAL_ROTATION_SPEED = 30;

export const MAX_FILTER_NAME_LENGTH = 255;
export const MIN_FILTER_NAME_LENGTH = 1;

export const MAX_TAG_NAME_LENGTH = 255;

export const MAX_METADATA_SETTINGS_NAME_LENGTH = 100;

export const MAX_FILTER_OPTION_NAME_LENGTH = 255;
export const MIN_FILTER_OPTION_NAME_LENGTH = 1;

export const NAME_SPECIAL_CHARS = /[\\\/:\.?'<>|]/g
export const NAME_SPECIAL_CHARS_V2 = /[^a-zA-Z \-0-9]/
export const NAME_ALLOWED_CHARS = /[a-zA-Z \-0-9]/g

export const MAX_3D_MODEL_PRODUCT_NAME_LENGTH = 100;

export const MAX_NAME_LENGTH = 255;
export const NAME_EXCLUDED_SPECIAL_CHARS_WITH_DOT = /[!@#$%^~`*+\=\[\]{};.':"\\|<>\/?]+/;
export const NAME_EXCLUDED_SPECIAL_CHARS = /[!@#$%^~`*+\=\[\]{};':"\\|<>\/?]+/;
export const NAME_EXCLUDED_SPECIAL_CHARS_GLOBAL = /[!@#$%^~`*+\=\[\]{};':"\\|<>\/?]+/ig;
export const NAME_EXCLUDED_SPECIAL_CHARS_V2_GLOBAL = /[!@#$&%^~`*+\=\[\]{}();':"\\|<>\/?]+/ig;
export const SPECIAL_CHARS_NOT_ALLOW_MESSAGE = `${"A file name can't contain any of the following characters: !@#$%^*+\/{};':\"<>`?|=~"}`

export const URL_VALIDATION = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;

export const LIGHT_NAME_MAX_LENGTH = 100;

export const CAMERA_NAME_MAX_LENGTH = 40;

export const RESOLUTION_PRESET_NAME_MAX_LENGTH = 40;

export const MESSAGE_DESCRIPTION_LENGTH = 250;


const ONE_MB = 1048576;
export const MAX_RENDER_IMAGE_FILE_SIZE = 50 * ONE_MB; 

export const CAMERA_VERTICAL_ROTATION_SPEED_MIN = 5;
export const CAMERA_VERTICAL_ROTATION_SPEED_MAX = 180;

export const CAMERA_HORIZONTAL_ROTATION_SPEED_MIN = 5;
export const CAMERA_HORIZONTAL_ROTATION_SPEED_MAX = 180;

export const CONFIGURATOR_TEMPLATE_NAME_MAX_LENGTH = 100;

export const CONFIGURATOR_NAME_MAX_LENGTH = 70;
export const CONFIGURATOR_LABEL_NAME_MAX_LENGTH = 70;
export const COLOR_NAME_MAX_LENGTH = 70;
export const LABEL_NAME_MAX_LENGTH = 70;
export const SCENE_NAME_MAX_LENGTH = 70;
export const VIEW_NAME_MAX_LENGTH = 70;
export const LABEL_OPTION_NAME_MAX_LENGTH = 70;
export const RETAIL_AUTOMATION_NAME_MAX_LENGTH = 70;
